import { useEffect } from 'react';

interface keyPressEvent {
    key: string
}

const useEscKeyPress = (onClose: ()=> void): void => {
    useEffect(() => {
        const handleEscKeyPress = ({ key }: keyPressEvent) => {
            if (key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keyup', handleEscKeyPress);
        return () => {
            document.removeEventListener('keyup', handleEscKeyPress);
        };
    }, [onClose]);
};

export default useEscKeyPress;
